import { Add, DeleteOutline, EditOutlined } from '@mui/icons-material'
import { Autocomplete, IconButton, Radio, Tab, Tabs, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import defaultImage from "../../assets/svg/defultImage.svg"
import { Controller, useForm } from 'react-hook-form'
// import DeleteModal from '../../components/Modals/DeleteModal'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
// import { newHost } from './Categories/CategoryProfile'
// import { newImageUrl } from './Manufacturers/ManufactureProfile'
import noData from "../../assets/svg/Emptyfile1.svg"
import { newHost } from '../../pages/Categories/CategoryProfile'
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile'
import DeleteModal from '../Modals/DeleteModal'

const Bundles = () => {
  const { user } = useSelector((state) => state.auth);
  const token = user?.token

 
  {/*Use Form*/ }
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,

  } = useForm({
     defaultValues: {
    category_id: ""
  }
  })
      


  {/*Add Bundle */ }
  const [bundleShow, setBundleShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [categories, setCategories] = useState([])
  
const options = categories.flatMap((cat) =>
  cat.subcategories.map((sub) => ({
    ...sub,
    mainCategoryName: cat.name, 
  }))
);



  const handleShow = () => {
    setBundleShow(true)
    
  }
  const handleClose = () => {
    setBundleShow(false)
    reset()
    setImagePreview(null)
    setIsEdit(false)
  }
  const getAllDoorStepCategory = async ()=>{
        try {
      const response = await axios.get(`${newHost}portal/doorstep-service-categories?type=main`,{
        headers:{Authorization:`Bearer ${token}`}
      })
      setCategories(response.data.data.categories)
      
    } catch (error) {
      console.log(error);
      
    }
  }

  const submitBundle = async (data) => {
    const formData = new FormData();


    if (data.profile_image && data.profile_image !== null) {
      formData.append("profile_image", data.profile_image);
    }

    formData.append("name", data.name);
    formData.append("category_id", data.category_id);
    formData.append("description", data.description);
    if(isEdit){
    try {
      const response = await axios.put(`${newHost}portal/price-plans/templates/${bundleId}`,
        formData
        , {
          headers: { Authorization: `Bearer ${token}` }
        })
        
      toast.success(response.data.message)
      getAllBundles()
      handleClose()
    } catch (error) {
      console.log(error);
      
      toast.error(error.response.data?.errors?.message)
    }
    }else{
    try {
      const response = await axios.post(`${newHost}portal/price-plans/templates`,
        formData
        , {
          headers: { Authorization: `Bearer ${token}` }
        })
        
      toast.success(response.data.message)
      getAllBundles()
      handleClose()
    } catch (error) {
      console.log(error);
      
      toast.error(error.response.data?.errors?.message)
    }
    }

  }
const handleUpdateBundle = (bundle)=>{
  console.log(bundle);
  
  setBundleShow(true)
  setIsEdit(true)
  setBundleId(bundle.id)
  setValue("name",bundle.name)
  setValue("description",bundle.description)
  setValue("category_id", bundle.category.id)
  if(bundle.profile_image_url){
    setImagePreview(`${newImageUrl}${bundle.profile_image_url}`)
  }
}

  useEffect(() => {
  
   getAllDoorStepCategory()
  }, [])
  
  {/*Delete Bundle*/ }

  const [showDelete, setShowDelete] = useState(false)
  const [bundleId, setBundleId] = useState(null)

  const handleDeleteShow = (id) => {
    setShowDelete(true)
    setBundleId(id)
  }
  const handleDeleteClose = () => {
    setShowDelete(false)
  }
  const deleteBundle = async () => {
    try {
      const response = await axios.delete(`${newHost}portal/price-plans/templates/${bundleId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.message)
      handleDeleteClose()
      getAllBundles()
    } catch (error) {
      toast.error(error.response?.data.errors?.message)
      toast.error(error.response?.data.message)

    }
  }
    {/* View Bundle */}
  const [bundles, setBundles] = useState([])
const getAllBundles = async () => {
  try {
    const response = await axios.get(
      `${newHost}portal/price-plans/templates`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          category_id: selectedTab,
        },
      }
    );

    setBundles(response.data.data.templates.data);
  } catch (error) {
    console.log(error);
  }
};

   {/*Filters*/}
   const [subCategories, setSubCategories] = useState([])
   const [selectedTab, setSelectedTab] = useState(null);
   
     const getAllSubCategories = async ()=>{
        try {
      const response = await axios.get(`${newHost}portal/price-plans/requests/subcategories-with-counts`,{
        headers:{Authorization:`Bearer ${token}`}
      })
      setSubCategories(response.data.data.categories_with_counts)
      
    } catch (error) {
      console.log(error);
      
    }
  }
  useEffect(() => {
    getAllSubCategories()
  }, [])
 useEffect(() => {
  if (subCategories.length > 0) {
    setSelectedTab(subCategories[0].id);
  }
}, [subCategories]);

useEffect(() => {
  if (!selectedTab) return;

  getAllBundles();
}, [selectedTab]);
  
  {/* Upload File */ }
  const [imagePreview, setImagePreview] = useState(null)
  const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setValue("profile_image", file);
    };
    reader.readAsDataURL(file);
  }


  return (
    <>
      {/* Delete Bundle */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this Bundle?"}
        deleteFunction={deleteBundle}
      />
      {/* Create Bundle Modal*/}
      <Modal show={bundleShow} onHide={handleClose} className="">
        <Modal.Header style={{ backgroundColor: "#F8F8F8" }}>
          <Modal.Title className="text-black">{isEdit? "Update Bundle":"Create New Bundle" }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-2">
            <form onSubmit={handleSubmit(submitBundle)}>
              <div className="my-2">
                <label htmlFor="name">Name</label>
                <TextField {...register("name")} id='name' className='w-100 my-1' size='small' placeholder="Add bundle name" />
              </div>
              <div className="my-1">
                <label className='my-1' htmlFor="category">Category</label>

      <Controller
  name="category_id"
  control={control}
  defaultValue={null}
  render={({ field }) => (
    <Autocomplete
      size="small"
      options={options}
      groupBy={(option) => option.mainCategoryName}
      getOptionLabel={(option) => option.name}

      value={options.find((opt) => opt.id === field.value) || null}

      onChange={(e, newValue) => {
        field.onChange(newValue ? newValue.id : null);
      }}

      renderGroup={(params) => {
        const mainCategory = categories.find(
          (cat) => cat.name === params.group
        );

        return (
          <li key={params.key}>
            <div
              className="d-flex align-items-center gap-2 px-3 py-2"
              style={{ fontWeight: 600,}}
            >
              <img
                src={
                  mainCategory?.icon_url
                    ? `${newImageUrl}${mainCategory.icon_url}`
                    : defaultImage
                }
                style={{ width: 20 }}
                alt=""
              />
              <span>{params.group}</span>
            </div>

            <ul style={{ padding: 0 }}>{params.children}</ul>
          </li>
        );
      }}

      renderOption={(props, option) => (
        <li {...props} className='px-1' >
          <Radio
            checked={field.value === option.id}
            onChange={() => field.onChange(option.id)}
            size="small"
            sx={{
              "&.Mui-checked": { color: "#000" },
            }}
          />

          <img
            src={
              option.icon_url
                ? `${newImageUrl}${option.icon_url}`
                : defaultImage
            }
            style={{ width: 18, marginInline: 8 }}
            alt=""
          />

          <span>{option.name}</span>
        </li>
      )}

      renderInput={(params) => (
        <TextField {...params} placeholder="Select Category" />
      )}
    />
  )}
/>



              </div>
              <div className="my-2">
                <label htmlFor="description">Description</label>
                <textarea {...register("description")} id='description' style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }} rows={3} className='w-100 my-1' type='text' placeholder='Enter bundle description'

                />
              </div>
              <div className="my-2">
                <label>Bundle icon</label>
                <div className="d-flex justify-content-between align-items-center p-4 company-logo-upload input-group-responsive my-1">
                  <div className="d-flex align-items-center upload-file-responsive">
                    <div style={{ width: "50px", height: "50px" }} className="">
                      <img
                        className="w-100"

                        src={
                          imagePreview
                            ? imagePreview
                            :
                            defaultImage
                        }
                        alt="profile_photo"
                      />
                    </div>



                    {imagePreview ? null : <p className="fw-bold my-0 mx-2 supplier-label-size">Upload an image. Max size 2MB</p>
                    }

                  </div>
                  <label htmlFor="profile_photo" className="btn btn-light">

                    Browser
                    <input onChange={FileChange} type="file" id="profile_photo" className="d-none " />


                  </label>

                </div>
              </div>
              <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
                <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
                <button className="btn btn-dark px-5">Save</button>

              </div>

            </form>
          </div>
        </Modal.Body>
      </Modal>

      <div className='min-vh-100 m-4'>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center header-responsive">
          <h5 className='fw-semibold m-0'>Bundles</h5>
          <button onClick={handleShow} className='btn btn-light' > <Add /> Add New Bundle  </button>
        </div>
        {/* tabs section */}
        <div
          className="tabs-section bg-light rounded-3 d-flex align-items-center my-3"
          style={{
            width: "fit-content",
            maxWidth: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            WebkitOverflowScrolling: "touch",
            height: "50px",
          }}
        >
          <Tabs
              value={selectedTab}
              onChange={(_, newValue) => setSelectedTab(newValue)
                
              }
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="dynamic tabs"
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              "& .MuiTabs-flexContainer": {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                width: "fit-content",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                borderRadius: "10px",
                minHeight: "40px",
                color: "#000",
                fontWeight: 500,
                transition: "all 0.3s ease",
              },
              "& .MuiTab-root.Mui-selected": {
                backgroundColor: "#000",
                color: "#fff",
              },
            }}
          >
            {subCategories.map((sub)=>
     <Tab
              key={sub.id}
              value={sub.id}
              label={
                <span className="tab-label">
                  {`${sub.name}`}
                </span>
              }
            />
            )}
       

          </Tabs>
        </div>
        {/* Bundles */}
        <div className="my-4 border rounded-2 min-vh-100 p-4">

          <div className="">
            {bundles.length > 0 ? bundles.map((bundle)=>
            <>
               <div className="border gap-2 rounded-2 d-flex align-items-center p-3 my-3">
              <img
                style={{ width: "40px" }}
                src={bundle.profile_image_url? `${newImageUrl}${bundle.profile_image_url}` : defaultImage}
              />
              <div
                className="w-100 bg-transparent"

              >
                <div className='d-flex justify-content-between align-items-center w-100'>

                  <h6 className="m-0 fw-semibold">{bundle.name}</h6>

                  <div className="row w-50 ">
                    <div className="col-md-6 d-flex justify-content-end align-items-center">
                      <img src={bundle.category?.icon_url? `${newImageUrl}${bundle.category?.icon_url}` : defaultImage} alt="" />
                      <h6 className='m-0'>{bundle.category?.name}</h6>
                    </div>
                    <div className="col-md-6 d-flex justify-content-end">
                      <IconButton onClick={()=>handleUpdateBundle(bundle)} sx={{ width: "25px" }} size='small' color='default'>
                        <EditOutlined sx={{ color: "" }} />
                      </IconButton>
                      <IconButton onClick={()=>handleDeleteShow(bundle.id)} sx={{ width: "25px" }} size='small' color='error'>
                        <DeleteOutline />
                      </IconButton>
                    </div>




                  </div>
                </div>
              </div>
            </div>
            </>
            ) : <>
                     <div className="flex flex-column text-center align-items-center ">
                          
                        <img src={noData} alt="no-data" />
                        <p style={{color:"#535353"}} className=''>No bundles yet. All your bundles will appear here once you get started.</p>
                    </div>
            
            </>}
         
 


          </div>
        </div>
      </div>



    </>
  )
}

export default Bundles